var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, Optional, Output, ViewChild, } from '@angular/core';
import { MatTabGroup } from '@angular/material';
import { ActivatedRoute, DefaultUrlSerializer, Router, } from '@angular/router';
import { GridModel, GridType, } from '@synisys/idm-dynamic-layout-interpreter';
import { isEmpty, isNil, uniq, isNaN, flatten, values } from 'lodash';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { ActionNotificationData, ActionNotifierKey } from '../../concepts';
import { TabIndexService } from '../../service/local/tab-index.service';
import { AbstractDestructionSubject } from '../abstract-destruction-subject';
import { DynamicLayout } from '../dynamic-layout';
import { DynamicFormComponent } from '../form';
import './grid.component.scss';
import { getDisplayFieldsNames, isControlApplicableToFields } from '../utilities';
var GridComponent = /** @class */ (function (_super) {
    __extends(GridComponent, _super);
    function GridComponent(route, router, location, tabIndexService) {
        var _this = _super.call(this) || this;
        _this.route = route;
        _this.router = router;
        _this.location = location;
        _this.tabIndexService = tabIndexService;
        _this.gridType = GridType;
        _this.tabChanged = new EventEmitter();
        _this.contentChecked = false;
        /**
         * Indicates if tab has validation errors.
         * If item with some index is false, tab with same index has validation error(s).
         *
         * @type {Array<boolean>}
         * @private
         */
        _this._tabsValidity = [];
        _this.urlSerializer = new DefaultUrlSerializer();
        return _this;
    }
    Object.defineProperty(GridComponent.prototype, "styleBlock", {
        get: function () {
            return this._styleBlock;
        },
        set: function (value) {
            this._styleBlock = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridComponent.prototype, "selectedTabIndex", {
        get: function () {
            return this._selectedTabIndex;
        },
        set: function (value) {
            this._selectedTabIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridComponent.prototype, "tabsVisibility", {
        get: function () {
            return this._tabsVisibility;
        },
        enumerable: true,
        configurable: true
    });
    GridComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._tabsVisibility = this.gridModel.rows.map(function () { return true; });
        this.initTabsValidity();
        if (this.layout.isForm()) {
            if (this.gridModel.type === GridType.TABULAR) {
                this.handleTabIndexFromUrl();
                this.layout.validationsChanged
                    .pipe(takeUntil(this.destroySubject$))
                    .subscribe(function (validations) { return _this.checkTabsValidity(validations); }, console.error);
            }
        }
    };
    GridComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.tabGroup && !this.contentChecked) {
            this.contentChecked = true;
            this.tabGroup.selectedTabChange
                .pipe(takeUntil(this.destroySubject$))
                .subscribe(function (matTabChangeEvent) {
                var selectedTabId = matTabChangeEvent.index;
                if (_this.layout.isForm()) {
                    _this.layout
                        .getActionNotifier()
                        .next(new ActionNotificationData(ActionNotifierKey.TAB_CHANGE_ACTION, selectedTabId));
                    _this.tabChanged.emit();
                    _this.setAnchor(selectedTabId);
                }
            }, console.error);
        }
    };
    GridComponent.prototype.isGridVisible = function () {
        if (!this.layout.isForm()) {
            return true;
        }
        return this.gridModel.properties && this.gridModel.properties.visibility
            ? this.gridModel.properties.visibility.predicate
                ? this.gridModel.properties.visibility.predicate(this.layout.getPredicateContext())
                : true
            : true;
    };
    GridComponent.prototype.getCustomTextValue = function (row) {
        return row.title.customText[this.layout.getCurrentLanguage().getId()];
    };
    GridComponent.prototype.getTabTitle = function (titleText) {
        return titleText === '' ? 'NEW TAB' : titleText;
    };
    GridComponent.prototype.isRowVisible = function (rowModel) {
        if (!this.layout.isForm()) {
            return true;
        }
        return rowModel.properties.visibility
            ? rowModel.properties.visibility.predicate
                ? rowModel.properties.visibility.predicate(this.layout.getPredicateContext())
                : true
            : true;
    };
    GridComponent.prototype.isTabInvalid = function (tabIndex) {
        return !this._tabsValidity[tabIndex];
    };
    GridComponent.prototype.validationEmittedFor = function (controlId) {
        var _this = this;
        this.gridModel.rows.forEach(function (row, index) {
            var rowIds = _this.getRowControlIds(row);
            if (rowIds.find(function (id) { return id === controlId; })) {
                _this._tabsValidity[index] = false;
            }
        });
    };
    GridComponent.prototype.trackByFunc = function (index, row) {
        return row.id;
    };
    GridComponent.prototype.setVisibility = function (visibility, index) {
        var _this = this;
        setTimeout(function () { return (_this.tabsVisibility[index] = visibility); });
    };
    GridComponent.prototype.initTabsValidity = function () {
        var _this = this;
        if (this.gridModel.type === GridType.TABULAR) {
            this.gridModel.rows.forEach(function (row, index) { return (_this._tabsValidity[index] = true); });
            if (this.layout instanceof DynamicFormComponent) {
                var action = this.layout.layoutActions.find(function (act) { return act.name === 'validationEmittedFor'; });
                action.func = function (controlId) {
                    _this.validationEmittedFor(controlId);
                };
                this.layout.actions[action.name] = action.func;
            }
        }
    };
    GridComponent.prototype.handleTabIndexFromUrl = function () {
        var _this = this;
        if (!(this.layout instanceof DynamicFormComponent) ||
            !this.layout.inDrawer) {
            this.route.fragment
                .pipe(distinctUntilChanged(), takeUntil(this.destroySubject$))
                .subscribe(function (fragment) {
                var tabIndex = Number(fragment);
                if ((!isNaN(tabIndex) && tabIndex >= 0) ||
                    tabIndex < _this.gridModel.rows.length) {
                    _this.selectedTabIndex = tabIndex;
                }
                else {
                    _this.selectedTabIndex = _this.layout.getInitialTabId();
                    _this.setAnchor(_this.selectedTabIndex);
                }
            }, console.error);
        }
    };
    GridComponent.prototype.setAnchor = function (selectedTabIndex) {
        if (!(this.layout instanceof DynamicFormComponent) ||
            !this.layout.inDrawer) {
            var parsed = this.urlSerializer.parse(this.router.url);
            var queryParamsStr = '';
            if (isEmpty(parsed.queryParams)) {
                parsed.fragment = selectedTabIndex.toString();
            }
            else {
                var queryParams = new HttpParams({
                    fromObject: parsed.queryParams,
                });
                parsed.fragment = undefined;
                parsed.queryParams = {};
                // Workaround: location.replaceState doesn't
                //              handle hash and queryParams correctly
                queryParamsStr =
                    queryParams.toString() + '#' + selectedTabIndex.toString();
            }
            if (!isNil(this.tabIndexService)) {
                this.tabIndexService.setIndex(selectedTabIndex);
            }
            this.location.replaceState(this.urlSerializer.serialize(parsed), queryParamsStr);
        }
    };
    GridComponent.prototype.checkTabsValidity = function (validations) {
        var _this = this;
        if (this.gridModel.type === GridType.TABULAR) {
            var invalidFields_1 = [];
            validations.forEach(function (validation) {
                invalidFields_1.push.apply(invalidFields_1, validation.getRelatedMetaFieldIds());
            });
            invalidFields_1 = uniq(invalidFields_1);
            if (!isEmpty(invalidFields_1)) {
                this.gridModel.rows.forEach(function (row, index) {
                    var rowControls = _this.getRowControls(row);
                    _this._tabsValidity[index] = !rowControls.some(function (rowControl) {
                        return validations.some(function (validation) {
                            return isControlApplicableToFields(validation.getRelatedMetaFieldIds(), values(rowControl.fields), getDisplayFieldsNames(validation));
                        });
                    });
                });
            }
            else {
                this.initTabsValidity();
            }
        }
    };
    GridComponent.prototype.getRowControlIds = function (row) {
        var _this = this;
        var ids = [];
        row.cells.forEach(function (cell) {
            if (cell.grid) {
                cell.grid.rows.forEach(function (innerRow) {
                    ids.push.apply(ids, _this.getRowControlIds(innerRow));
                });
            }
            else {
                ids.push(cell.controlModel.id);
            }
        });
        return ids;
    };
    GridComponent.prototype.getRowControls = function (row) {
        var _this = this;
        var controlModel = [];
        row.cells.forEach(function (cell) {
            if (cell.grid) {
                cell.grid.rows.forEach(function (innerRow) {
                    controlModel.push(_this.getRowControls(innerRow));
                });
                controlModel = flatten(controlModel);
            }
            else {
                controlModel = [cell.controlModel];
            }
        });
        return controlModel;
    };
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], GridComponent.prototype, "styleBlock", null);
    __decorate([
        ViewChild('tabGroup', { read: MatTabGroup }),
        __metadata("design:type", MatTabGroup)
    ], GridComponent.prototype, "tabGroup", void 0);
    __decorate([
        Input(),
        __metadata("design:type", GridModel)
    ], GridComponent.prototype, "gridModel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], GridComponent.prototype, "tabId", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], GridComponent.prototype, "tabChanged", void 0);
    __decorate([
        Input(),
        __metadata("design:type", DynamicLayout)
    ], GridComponent.prototype, "layout", void 0);
    GridComponent = __decorate([
        Component({
            moduleId: module.id + '',
            selector: 'grid',
            template: require('./grid.component.html'),
        }),
        __param(3, Optional()),
        __metadata("design:paramtypes", [ActivatedRoute,
            Router,
            Location,
            TabIndexService])
    ], GridComponent);
    return GridComponent;
}(AbstractDestructionSubject));
export { GridComponent };
//# sourceMappingURL=grid.component.js.map